export default "__VITE_ASSET__CjjnNuAO__"